import { Injectable } from '@angular/core';
import { AbstractContentfulStateService, IContentfulExportType } from '@y42/contentful';
import { Entry } from 'contentful';
import { ExportTypeEnum } from '../export-type.enum';
import { ExportCTypeModel } from './export-type.model';

@Injectable({ providedIn: 'root' })
export class ExportTypeContentfulService extends AbstractContentfulStateService<
  IContentfulExportType<ExportTypeEnum>,
  ExportCTypeModel
> {
  constructor() {
    super('automationType', '', 1000, (c: Entry<IContentfulExportType<ExportTypeEnum>>) => {
      return {
        type: c.fields.type,
        displayName: c.fields.datasourcetype?.fields.displayName,
        description: c.fields.description,
        logo: c.fields.datasourcetype?.fields.logo?.fields.file.url || '',
        orderNo: c.fields.datasourcetype?.fields.orderNo,
        availabilityLabel: c.fields.availability,
        industry: c.fields.datasourcetype?.fields.industry,
        color: c.fields.datasourcetype?.fields.color,
        articleid: c.fields.datasourcetype?.fields.articleid,
        articleidAuth: c.fields.datasourcetype?.fields.articleidAuth,
        scheduleTime: c.fields.datasourcetype?.fields.scheduleTime,
        documentationUrl: c.fields.datasourcetype?.fields.documentationUrl,
        rawGuideUrl: '',
        isAirbyte: c.fields.datasourcetype?.fields.isAirbyte,
        hasIncremental: c.fields.datasourcetype?.fields.hasIncremental,
        pictureUrl: c.fields.datasourcetype.fields.pictureUrl,
        authTutorial: c.fields.datasourcetype.fields.authTutorial?.content[0]?.content[0]?.value,
      };
    });
  }
}
